/* unplugin-vue-components disabled */import script from "./officialDocPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./officialDocPreview.vue?vue&type=script&setup=true&lang=ts"

import "./officialDocPreview.vue?vue&type=style&index=0&id=30bc6038&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30bc6038"]])

export default __exports__